import React, { Component } from "react";
import Select from "react-select";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import axios from 'axios';
import { fetchCustomers, fetchActiveCustomers } from '../../../../actions/customers_actions';
import GenericSelection from '../../../Common/GenericSelection';
import { ROOT_URL } from '../../../../actions/root_url';

import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import { SkyLightStateless } from 'react-skylight';
import { throttle } from 'lodash';
const propTypes = {
}

const defaultProps = {
}

const modalStyle = {
  width: '600px',
  height: '300px',
  marginLeft: '-10%'
}

const handleUpload = (platform, formData, selectedCompany, selectedWarehouse, customer, success, failed) => {
  axios({
    method: 'post',
    url: `${ROOT_URL}v2/import_sales_order/?platform=${platform}&company_id=${selectedCompany.value}&warehouse_id=${selectedWarehouse.value}&customer_id=${customer.value}`,
    data: formData,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success();
    })
    .catch(err => {
      failed(err.data);
    })
}

export class CreateExcelModal extends Component {
  constructor() {
    super();
    this.state = {
      selectedCustomer: null,
      file: null,
      platform: null,
      uploading: false,
    };
  }

  componentDidMount() {
    this.props.fetchCustomers();
  }

  handleOnSubmit = (e) => {
    if (!this.state.selectedCustomer) {
      alert('customer is required');
      return;
    }
    if (!this.state.platform) {
      alert('platform is required');
      return;
    }
    if (!this.state.file) {
      alert('file is required');
      return;
    }
    this.setState({
      uploading: true,
    })
    const {
      platform,
      selectedCustomer,
      file,
    } = this.state;

    const {
      selectedCompany,
      selectedWarehouse,
    } = this.props;

    const formData = new FormData();
    formData.append('FILE', file);
    handleUpload(platform, formData, selectedCompany, selectedWarehouse, selectedCustomer, () => {
      this.props.handleUploadSuccess();
      alert('Success')
      this.setState({
        uploading: false,
        selectedCustomer: null,
        platform: null,
        file: null,
      })
    }, (err) => {
      alert(JSON.stringify(err));
      this.setState({
        uploading: false,
      })
    })
  };

  handleSubmit = throttle(this.handleOnSubmit, 1000);

  getCustomersOption = () => {
    return this.props.customers.map(c => ({
      label: `${c.CustomerNum} - ${c.Name}`,
      value: c.Customer_id,
    }))
  }
  render() {
    const {
      selectedBatch,
    } = this.state;
    const {
      setModalVisibility,
      isVisible,
      customers,
    } = this.props;
    return (
      <SkyLightStateless
        title={'Create Excel'}
        onCloseClicked={setModalVisibility}
        dialogStyles={modalStyle}
        isVisible={isVisible}
      >
        <div>
          <Row>
            <Col>
              <div className="reassignGFD" style={{ marginTop: '10px', marginBottom: "30px", display: 'flex', justifyContent: 'center' }}>
                <label style={{ margin: '6px' }}>
                  <Translate value="customer" />:
                </label>
                <GenericSelection
                  options={this.getCustomersOption()}
                  value={this.state.selectedCustomer}
                  setSelected={selectedCustomer => this.setState({ selectedCustomer })}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col style={{ display: 'flex', justifyContent: 'center' }}>
              <span style={{ width: '100px' }}>
                <input
                  type="radio"
                  name="ocm-create-excel"
                  value="hongmall"
                  checked={this.state.platform === 'hongmall'}
                  onChange={(e) => this.setState({ platform: e.target.value })}
                />
                HONGMALL
              </span>
              <span style={{ width: '100px' }}>
                <input
                  type="radio"
                  name="ocm-create-excel"
                  value="yamibuy"
                  checked={this.state.platform === 'yamibuy'}
                  onChange={(e) => this.setState({ platform: e.target.value })}
                />
                YAMIBUY
              </span>
              <span style={{ width: '100px' }}>
                <input
                  type="radio"
                  name="ocm-create-excel"
                  value="weee"
                  checked={this.state.platform === 'weee'}
                  onChange={(e) => this.setState({ platform: e.target.value })}
                />
                WEEE
              </span>
            </Col>
          </Row>
          <Row>
            <Col style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
              <input
                type="file"
                onChange={(e) => {
                  const file = e.target.files[0];
                  this.setState({
                    file,
                  });
                }}
              />
            </Col>
          </Row>
          <Row style={{ position: 'absolute', bottom: '25px', display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Button
              bsStyle="success"
              onClick={() => {
                this.handleSubmit();
              }}
              disabled={this.state.uploading}
            >
              <Translate value={this.state.uploading ? 'uploading' : 'upload'} />
            </Button>
          </Row>
        </div >
      </SkyLightStateless >
    );
  }
}

CreateExcelModal.propTypes = propTypes
CreateExcelModal.defaultProps = defaultProps

const mapState = (state) => ({
  customers: state.customers.all,
  selectedWarehouse: state.header.selectedWarehouse,
  selectedCompany: state.header.selectedCompany,
});

export default connect(mapState, {
  fetchCustomers,
})(CreateExcelModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/CreateExcelModal.jsx